import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
//#region src/modules/Reports/hooks/useReports.ts
function useReports(args, opts = {}) {
	const { call, data, isCalling } = useRPC(RPCs.Reports.GetReportsList.v1, args, {
		cacheStrategy: opts.cacheStrategy,
		fire: !!args
	});
	return {
		data,
		loading: isCalling,
		refresh: call
	};
}
//#endregion
export { useReports };

//# sourceMappingURL=useReports.js.map